import React, {useEffect} from 'react';
import TopBar from '../../../Components/TopBar';
import Page from '../../../Components/Containers/Page';
import DayAppointmentsView from './DayAppointmentsView';
import Icon from '../../../Components/Icons/Icon';
import { useCalendarContext } from '../Provider';
import DayHeaderView from './DayHeaderView';
import Intro from '../Modals/Intro';
import { useSession } from '../../../Components/Session';
import Toggle from '../../../Components/Button/Toggle';

const Old = ({calendarContainerRef, headerContainerRef, appointmentsContainerRef}) => {
    const {
        calendar, hasOptimisationIssues, selectedWeek, weekOptions, days,
        setOptimisationIssuesOpen, setFilling, setConfirming,
        dayWidth, pxPerHour, handleResize, headerExpanded, toggleHeaderExpanded,
        setNewCalendar,
    } = useCalendarContext();
    const {isAdmin} = useSession();

    useEffect(() => {
        setTimeout(() => {
            calendarContainerRef?.current?.scrollTo({
                top: pxPerHour * 9,
                behavior: calendarContainerRef.current.scrollTop ? 'smooth' : 'instant'
            });
        }, 50);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [calendarContainerRef, headerContainerRef, appointmentsContainerRef, calendar]);

    return <>
        <TopBar title="Calendar"
            dropdownIcon="CalendarWeek"
            dropdownOptions={weekOptions}
            shadow={false}
            // left={isAdmin() ? <Button theme="light" icon="Gift" onClick={() => setNewCalendar(true)} zeroMargin /> : null}
            left={isAdmin() && <div className="flex flex-row items-center justify-around gap-x-2 fill-brand text-nowrap">
                <Toggle onChange={() => setNewCalendar(true)} />
                <Icon icon="Gift" inline />
            </div>}
        />
        <div className="overflow-x-contain">
            <div className="overflow-x-scroll" ref={calendarContainerRef}>

                {/* Header */}
                <div ref={headerContainerRef}
                    className="sticky top-0 z-25 backdrop-blur-md bg-white/80 border-b shadow-md w-full"
                    style={{minWidth: (dayWidth * days.length) + 15}}
                >
                    <div className="flex flex-row">
                        {days.map((day, i) => <DayHeaderView key={i}
                            day={day}
                            appointments={calendar?.appointments?.appointments?.[day.date] ?? null}
                            scheduledWithoutAppointments={calendar?.scheduledWithoutAppointments?.[day.date] ?? null}
                        />)}
                    </div>
                    <p className="sticky left-0 w-[100vw] page-container text-center text-muted fill-muted text-xs cursor-pointer py-1 bg-blue-100/20"
                        onClick={() => toggleHeaderExpanded()}
                    >
                        <span className="mr-2">{headerExpanded ? 'Hide jobs without times' : 'Show jobs without times'}</span>
                        <Icon icon={headerExpanded ? 'UpChevrons' : 'DownChevrons'} size="0.5x" inline />
                    </p>
                </div>

                {/* Appointments */}
                <Page scrollContainerRef={appointmentsContainerRef}
                    additionalOffsetRef={headerContainerRef}
                    overflow="overflow-visible"
                    resizeWatch={[dayWidth, pxPerHour, headerExpanded, calendar]}
                >
                    <div className="flex flex-row">
                        {days.map((day, i) => <DayAppointmentsView key={i}
                            day={day}
                            appointments={calendar?.appointments?.appointments?.[day.date] ?? null}
                            scheduledWithoutAppointments={calendar?.scheduledWithoutAppointments?.[day.date] ?? null}
                        />)}
                    </div>
                </Page>
            </div>

            <div className="relative page-container">
                <div className="absolute bottom-2 md:bottom-4 right-2 z-30 p-2 rounded-xl backdrop-blur-md bg-slate-100/50 border border-slate-100 shadow">
                    {hasOptimisationIssues &&
                        <button className="btn-sm md:btn btn-warning shadow mr-2" onClick={() => setOptimisationIssuesOpen(true)}>
                            <Icon icon="TriangleExclamation" theme="solid" size="0.5x" /> Incomplete
                        </button>
                    }
                    {/* Add the rounded-none classes with the md: condition too, so they aren't overridden by md:btn */}
                    <button className="btn-sm md:btn btn-light shadow rounded-tr-none rounded-br-none md:rounded-tr-none md:rounded-br-none" onClick={() => handleResize(-1)}>
                        <Icon icon="Minus" size="0.5x" />
                    </button>
                    <button className="btn-sm md:btn btn-light shadow rounded-tl-none rounded-bl-none md:rounded-tl-none md:rounded-bl-none -ml-px mr-2" onClick={() => handleResize(1)}>
                        <Icon icon="Plus" size="0.5x" />
                    </button>
                    <button className="btn-sm md:btn btn-secondary shadow mr-2" onClick={() => setConfirming({week: selectedWeek})}>
                        <span className="font-normal">Confirm</span>
                    </button>
                    <button className="btn-sm md:btn btn-primary shadow" onClick={() => setFilling(true)}>
                        <span className="font-normal">Plan</span>
                    </button>
                </div>
            </div>
        </div>

        <Intro />
    </>
}

export default Old;